<template>
<v-card flat>
    <v-card-title class='subheading' >
      <v-flex>
        {{ $t('logs.historical') }}. <br/>
        <small>{{ $t('logs.historicalsubtitle') }}</small>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex>
        <v-text-field
          label='Search'
          v-model='searchString'
          append-icon="search" clearable >
        </v-text-field>
        <v-progress-circular
          v-if='treatmentLogsRequest.loading'
          color='amber' size='20'
          width='2' indeterminate >
        </v-progress-circular>
      </v-flex>
    </v-card-title>
    <v-divider></v-divider>
    <v-timeline dense clipped class='mb-4 ml-3'>
      <v-timeline-item
        v-if='searchString && searchString.length > 0' class='subheading' hide-dot >
        {{ $t('logs.searchinfo', {string: searchString}) }}
      </v-timeline-item>
      <v-timeline-item v-else
        hide-dot class="subheading" >
        {{ $tc('logs.summary', historicalTreatmentLogs.length, {n: historicalTreatmentLogs.length, from: oldestAppointmentDate}) }}<br/>
        <span v-if='historicalTreatmentLogs.length > 0' >
        {{ $t('logs.lastseen', {date: mostRecentAppointmentDate}) }}
        </span>
      </v-timeline-item>
      <template v-for='(log, index) in filteredHistoricalTreatmentLogs' >
        <v-timeline-item
          v-if='isNewDate(log, index, filteredHistoricalTreatmentLogs)'
          :key='`dt-${index}`'
          class='mt-3' >
          <template slot='icon' >
            <v-icon dark small >event</v-icon>
        </template>
          <span class='subheading'>{{ luxonDateformat(log.last_used, 'ccc d MMM yyyy') }}</span>
        </v-timeline-item>
        <v-timeline-item
          :key='index' small
          class="mb-0" color="pink"
          icon-color="grey lighten-2" >
          <v-layout justify-space-between>
            <v-flex xs7 >
              <div >
                <strong>{{log.code}}</strong> <!-- {{log.process}} -->
                {{ $tc('logs.count', log.count, {n: log.count}) }}
              </div>
              <div v-if='log.count > 1' >
                {{ luxonDateformat(log.first_used, 'ccc d MMM yyyy') }} -
                {{ luxonDateformat(log.last_used, 'ccc d MMM yyyy') }}
              </div>
              <div v-else >
                {{ luxonDateformat(log.first_used, 'ccc d MMM yyyy') }}
              </div>
            </v-flex>
            <!-- <v-flex xs5 text-xs-right>
              <v-btn small flat >Show appointments</v-btn>
            </v-flex> -->
          </v-layout>
        </v-timeline-item>
      </template>
      <template v-if='!treatmentLogsRequest.loading' >
        <v-timeline-item v-if='historicalTreatmentLogs && historicalTreatmentLogs.length === 0' >
          {{ $t('zeroresults') }}
        </v-timeline-item>
        <v-timeline-item v-if='historicalTreatmentLogs.length > 0 && filteredHistoricalTreatmentLogs && filteredHistoricalTreatmentLogs.length === 0' >
          {{ $t('zerosearchresults') }}
        </v-timeline-item>
      </template>
    </v-timeline>
  </v-card>
</template>
<script>
export default {
  name: 'HistoricalUsage',
  data () {
    return {
      reqId: 'get-code-history',
      searchString: ''
    }
  },
  props: {
    clientId: { required: true },
    relationshipId: { required: true }
  },
  methods: {
    getCodes () {
      let suffix = this.relationshipId + '/codes'
      this.$appointmentguru
        .resource('practitioner.clients')
        .id(this.reqId)
        .get(suffix)
    },
    isNewDate (log, index, logs) {
      if (index === 0) { return true }
      let last = logs[index - 1]
      return (log[this.orderByValue] !== last[this.orderByValue])
    }
  },
  watch: {
    clientId: {
      immediate: true,
      handler () {
        if (this.relationshipId) {
          this.getCodes()
        }
      }
    }
  },
  computed: {
    orderByText () {
      if (this.orderByLastUsed) {
        return this.$t('lastused')
      }
      return this.$t('firstused')
    },
    orderByValue () {
      if (this.orderByLastUsed) {
        return 'last_used'
      }
      return 'first_used'
    },
    mostRecentAppointmentDate () {
      if (this.sortedHistoricalTreatmentLogs && this.sortedHistoricalTreatmentLogs.length > 0) {
        let dt = this.sortedHistoricalTreatmentLogs[0].last_used
        return this.luxonDateformat(dt, 'ccc d MMM yyyy')
      }
    },
    oldestAppointmentDate () {
      if (this.sortedHistoricalTreatmentLogs && this.sortedHistoricalTreatmentLogs.length > 0) {
        let codes = this.sortedHistoricalTreatmentLogs
        let dt = codes[codes.length - 1].last_used
        return this.luxonDateformat(dt, 'ccc d MMM yyyy')
      }
    },
    treatmentLogsRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    historicalTreatmentLogs () {
      if (this.treatmentLogsRequest.status <= 200) {
        return this.getObjectPath(this.treatmentLogsRequest, 'result.data', [])
      }
      return []
    },
    sortedHistoricalTreatmentLogs () {
      if (!this.historicalTreatmentLogs) { return [] }
      let order = this.orderByValue || 'last_used'
      return this.historicalTreatmentLogs.sort((a, b) => {
        if (a[order] === b[order]) { return 0 }
        if (a[order] > b[order]) { return -1 }
        return 1
      })
    },
    filteredHistoricalTreatmentLogs () {
      let sorted = this.sortedHistoricalTreatmentLogs
      if (this.searchString && this.searchString.length > 0) {
        return sorted.filter((log) => {
          if (log.code) {
            return (log.code.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1)
          }
        })
      }
      return sorted
    }
  },
  i18n: {
    messages: {
      en: {
        timesUsed: 'Never used | Used once | Used {count} times',
        zeroresults: 'No codes found on appointments for this client',
        zerosearchresults: 'Your search returned no results',
        lastused: 'last used',
        firstused: 'first used',
        logs: {
          historical: 'Codes previously used',
          historicalsubtitle: '(sorted by last time used)',
          count: 'Never used|Used once|Used twice|Used {n} times',
          summary: '{n} codes used | {n} code used since {from} | {n} codes used since {from}',
          searchinfo: 'Searching for {string}',
          lastseen: 'Last seen: {date}'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// HistoricalUsage.vue?3c1760c3